import React, { useEffect, useState } from "react";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { IModel, IRFPDepartment } from "./RFPPOCDepartmentMast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Fetch } from "../../../shared/Fetch";
import { Dialog } from "primereact/dialog";
import { Tooltip } from "primereact/tooltip";
import { Tag } from "primereact/tag";
interface Iprops {
  setModal: (modal: IModel) => void;
  toast: any;
  reload: boolean;
  permissions: IPermissionProps;
  setReload: (is: boolean) => void;
}
const Table = (props: Iprops) => {
  const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IRFPDepartment>; loading: boolean });
  const [descriptionDialog, setDescriptionDialog] = useState<{ visible: boolean; description: string }>({ visible: false, description: "" });
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  const DateFormat = loginObj.date_Format;
  const openEdit = (rowDatauser: IRFPDepartment) => {
    props.setModal({ open: true, singleData: rowDatauser });
  };
  const actionBodyTemplate = (rowData: IRFPDepartment) => {
    return (
      <div className="actions">
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
      </div>
    );
  };
  const leftToolbarTemplate = () => {
    return (
      <>
        <div className="my-2">
          <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
        </div>
      </>
    );
  };
  const openNew = () => {
    props.setModal({ singleData: {}, open: true });
  };
  const loadDepartment = async () => {
    try {
      setTableData((prev: any) => ({ ...prev, loading: true }));
      const response = await Fetch("RFP_POC_Department_Mast/GetDepartment", "GET", null, null, props.toast);
      if (response?.ok) {
        const data = await response.json();
        setTableData({ tableData: data, loading: false });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setTableData((prev) => ({ ...prev, loading: false }));
    }
  };
  useEffect(() => {
    loadDepartment();
  }, [props.reload]);

  const toggleStatus = async (rowData: IRFPDepartment) => {
    try {
      const response = await Fetch(`RFP_POC_Department_Mast/UpdateStatus/${rowData.id}`, "PUT", { isActive: !rowData.isActive }, null, props.toast);

      if (response?.ok) {
        props.setReload(!props.reload);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <Toolbar left={leftToolbarTemplate} className="mb-3" />
      <DataTable value={tableData.tableData} style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0" }} size="small" stripedRows showGridlines responsiveLayout="scroll" header="RFP Department" loading={tableData.loading}>
         <Column header="S.No" body={(_, opt) => opt.rowIndex + 1} />
        <Column field="department" header="Department" />
        <Column
          header="Description"
          body={(rowData: IRFPDepartment) =>
            rowData.description ? (
              <>
                <Tooltip target=".view-description" />
                <i className="pi pi-eye view-description cursor-pointer" data-pr-tooltip="View Description" data-pr-position="top" style={{ color: "var(--primary-color)", fontSize: "1.2rem" }} onClick={() => setDescriptionDialog({ visible: true, description: rowData.description || "" })} />
              </>
            ) : (
              "-"
            )
          }
        />
        <Column header="Active" body={(rowData: IRFPDepartment) => <Tag value={rowData.isActive ? "Yes" : "No"} severity={rowData.isActive ? "success" : "danger"} style={{ cursor: "pointer" }} onClick={() => toggleStatus(rowData)} />} />
        <Column field="added_By" header="Added By" />
        <Column field="update_By" header="Updated By" />
        <Column field="update_At" header="Updated On" body={(rowData: any) => safeFormatDate(rowData.update_At, "dd/MM/yyyy", DateFormat)} style={{ maxWidth: "120px" }} />
        <Column header="Added At" body={(rowData: any) => safeFormatDate(rowData.added_At, "dd/MM/yyyy", DateFormat)} style={{ maxWidth: "120px" }} />
        <Column header="Actions" body={actionBodyTemplate} />
      </DataTable>
      {/* Decription Dialog */}
      <Dialog header="Description" visible={descriptionDialog.visible} modal style={{ width: "40vw" }} onHide={() => setDescriptionDialog({ visible: false, description: "" })}>
        <p style={{ whiteSpace: "pre-wrap" }}>{descriptionDialog.description}</p>
      </Dialog>
    </>
  );
};

export default Table;
